export enum EasmDnsRecordsEvents {
  DATA_CLICK = 'easm-dns-records-data-click',
  LEGEND_CLICK = 'easm-dns-records-legend-click',
}

export enum EasmDnsRecordsChartType {
  ACTIVE = 'active',
  EMPTY = 'empty',
}

export enum EasmDnsRecordsWidgetSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export interface ChartClickInfo {
  chartSvgRect: DOMRect;
  svgEventX: number;
  svgEventY: number;
}
